import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Typography } from '@mui/material'
import classNames from 'classnames'
import Wrapper from '@app/components/Common/Wrapper/Wrapper'
import { ChevronLeft } from 'icons'
import { IZwaveOrTwrDevice } from '@app/@types/myDevices'
import useStyles from './ZwaveDetailsCard.style'

interface Props {
  currentDevice: IZwaveOrTwrDevice,
  isMobile: boolean,
}

const ZwaveDetailsCard: React.FC<Props> = (props) => {
  const { currentDevice, isMobile } = props
  const navigate = useNavigate()
  const { classes } = useStyles()

  return (
    <>
      <Wrapper
        className={classNames(classes.settingsCard, isMobile && classes.settingsCardMobile)}
        onClick={() => {
          navigate(`/web/my_devices/info/zwave_device/${currentDevice.id}/settings/zwave_details`)
        }}
      >
        <Typography className={classNames(classes.mainTitle)}>Z-Wave details</Typography>
        <Typography className={classNames(classes.cardTitle)}>Device recognised</Typography>
        <ChevronLeft className={classes.arrowRightIcon} />
      </Wrapper>
    </>
  )
}

export default ZwaveDetailsCard
